import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { State } from "../../store";
import useTickets from "./hooks/useTickets";
import LimitedTicketBlock from "./LimitedTicketBlock";
import "../../../style/feature.scss";
import "../../../style/block.scss";
import "./style.scss";
import useFacility from "../../../utils/hooks/useFacility";
import EAPageHeader from "../shared/EAPageHeader";
import EAPageMessage from "../shared/EAPageMessage";
import { useTranslation } from "react-i18next";
import EAAlert from "../shared/EAAlert";
import { checkComponentActive } from "../../../utils/checkComponentActive";

const LimitedTicketGroupPage: React.FC = () => {
  const { t } = useTranslation();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const facilityIds = useFacility();
  const { assortGroup, requestGetAssortGroups } = useTickets();

  useEffect(() => {
    requestGetAssortGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  if (checkComponentActive(saleConfiguration.componentList, "Groups") === false) {
    return <EAAlert message={t("Nie znaleziono oferty")} type="error" />;
  }

  return (
    <>
      <div className="container">
        <EAPageHeader componentId="Groups" />
        <EAPageMessage message={saleConfiguration.message_groups} />

        {assortGroup && (
          <div className="limited-ticket-wrapper">
            {assortGroup.map((item, index) => (
              <LimitedTicketBlock item={item} sortType="assortGroup" key={index} />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default LimitedTicketGroupPage;
